







import Vue from "vue";
import Component from "vue-class-component";

@Component({
  name: "SearchError",
})
export default class SearchError extends Vue {}
